var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteStrikethrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8213 9.21646H16.6079C16.6079 5.01454 16.607 0.400391 16.607 0.400391H15.2771V9.21646H0.821289V10.392H15.2771V11.5676H0.821289V12.7432H15.2771V13.954C14.3508 13.4561 13.0613 13.371 11.8014 13.82C10.4728 14.2939 9.5089 15.2433 9.16908 16.2696H0.821289V17.4452H9.06449C9.08808 17.5863 9.12471 17.7264 9.17529 17.8638C9.73825 19.379 11.8268 20.0253 13.8403 19.3072C14.9134 18.9248 15.6797 18.2374 16.1297 17.4452H24.821V16.2696H16.5554C16.5889 16.0769 16.6066 15.8832 16.6066 15.6914C16.6073 15.2147 16.6076 14.1285 16.6076 12.7432H24.821V11.5676H16.6076C16.6076 11.1879 16.6076 10.7942 16.6076 10.392H24.821V9.21646H24.8213Z",
    fill: "#F87E03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteStrikethrough);
export default __webpack_public_path__ + "static/media/note_strikethrough.722d1be906ec126c790b08fc61b444bd.svg";
export { ForwardRef as ReactComponent };